/*  ROUTE_METADATA is defined separately from ROUTES
    to avoid circular dependencies when accessing this data in other files.

    Path conventions:
    - Absolute paths (e.g. '/admin/outreach/tags') are used here for entries
      that are referenced in navigate() calls and link construction.
    - Relative paths (e.g. 'overview', 'devices') are used for entries that
      correspond to nested <Route> definitions under a parent layout route.
    - The ROUTES object in consts.js uses relative paths for React Router's
      nested route matching; ROUTE_METADATA uses absolute paths for navigation. */
export const ROUTE_METADATA = {
  accessTokens: {
    path: 'access-tokens',
    title: 'Access Tokens',
  },
  clients: {
    path: 'clients',
  },
  cookiePreferences: {
    path: 'cookie-preferences',
    title: 'User Settings',
  },
  daily: {
    path: 'daily',
    title: 'Daily View',
  },
  details: {
    path: 'details',
  },
  deviceId: {
    path: ':deviceId',
  },
  devices: {
    path: 'devices',
  },
  editPatient: {
    path: 'manage',
    title: 'Settings',
  },
  log: {
    path: 'log',
    title: 'Patient Log',
  },
  organizations: {
    path: '/organizations',
    title: 'Organizations',
  },
  admin: {
    path: '/admin',
    title: 'Admin',
  },
  adminOutreachDashboard: {
    path: '/admin/outreach/dashboard',
    title: 'Outreach Dashboard',
  },
  adminOutreachTags: {
    path: '/admin/outreach/tags',
    title: 'Tags',
  },
  adminOutreachTemplates: {
    path: '/admin/outreach/templates',
    title: 'Templates',
  },
  adminOutreachCampaigns: {
    path: '/admin/outreach/campaigns',
    title: 'Campaigns',
  },
  adminOutreachHighlightCards: {
    path: '/admin/outreach/highlight-cards',
    title: 'Highlight Cards',
  },
  adminOutreachHighlightCardDetails: {
    path: '/admin/outreach/highlight-cards/:cardId',
    title: 'Highlight Card Details',
  },
  adminOutreachCardContentEditor: {
    path: '/admin/outreach/highlight-cards/:cardId/content',
    title: 'Edit Card Content',
  },
  adminOutreachPushNotifications: {
    path: '/admin/outreach/push-notifications',
    title: 'Push Notifications',
  },
  adminOutreachTemplateNew: {
    path: '/admin/outreach/templates/new',
    title: 'New Template',
  },
  adminOutreachTemplateEdit: {
    path: '/admin/outreach/templates/:templateId',
    title: 'Edit Template',
  },
  adminOutreachCampaignDashboard: {
    path: '/admin/outreach/campaigns/:campaignId',
    title: 'Campaign Dashboard',
  },
  adminOutreachCampaignEdit: {
    path: '/admin/outreach/campaigns/:campaignId/edit',
    title: 'Edit Campaign',
  },
  adminOutreachTagNew: {
    path: '/admin/outreach/tags/new',
    title: 'New Tag',
  },
  adminOutreachTagEdit: {
    path: '/admin/outreach/tags/:tagId',
    title: 'Tag Details',
  },
  adminCompliance: {
    path: '/admin/compliance',
    title: 'Compliance',
  },
  aiChat: {
    path: '/ai-chat',
    title: 'AI Chat',
  },
  overview: {
    path: 'overview',
    title: 'Overview',
  },
  patientId: {
    path: ':patientId',
  },
  patients: {
    path: '/patients',
    title: 'All Patients',
  },
  profile: {
    path: 'profile',
    title: 'User Settings',
  },
  reportClinician: {
    path: 'reportClinician',
    title: 'Clinician Report',
  },
  reportPatient: {
    path: 'report',
    title: 'Patient Report',
  },
  reportPatientPDFTest: {
    path: 'reportPatientPDFTest',
    title: 'Test Patient Report PDF',
  },
  settings: {
    path: '/settings',
    title: 'User Settings',
  },
  signin: {
    path: '/signin',
  },
  summary: {
    path: 'summary',
    title: 'Detail View',
  },
  summaryComparison: {
    path: 'summaryComparison',
    title: 'Detail View',
  },
  taskNotifications: {
    path: 'task-notifications',
  },
  users: {
    path: '/users',
    title: 'Team',
  },
  weeklyView: {
    path: 'weeklyView',
    title: 'Weekly View',
  },
}
